var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$vuetify.breakpoint.mobile)?[_c('Desktop')]:_vm._e(),(_vm.$vuetify.breakpoint.mobile)?[_c('Mobile')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }